import { useEffect, } from "react";
import createCustomTheme from './theme'
import {ThemeProvider} from "@mui/material";
import Vtec from "../../pages/vtec/Vtec";
import './PreviewTheme.css'

export default function PreviewTheme({ partnerTheme }){
  const theme = createCustomTheme(partnerTheme?.primaryColor, partnerTheme?.bgColor, partnerTheme.highlight);

  useEffect(() => {
    const updated = createCustomTheme(partnerTheme?.primaryColor, partnerTheme?.bgColor, partnerTheme.highlight);

    const root = document.getElementsByClassName("preview-theme")[0];
    root?.style.setProperty('--gradient-default-nav', `linear-gradient(to right, ${updated.palette.primary.main}, ${updated.palette.secondary.main})`); 
    root?.style.setProperty('--gradient-default', `linear-gradient(to left,${updated.palette.primary.main}, ${updated.palette.secondary.main})`);
    root?.style.setProperty('--gradient-default-bottom', `linear-gradient(to bottom, ${updated.palette.primary.main}, ${updated.palette.secondary.main})`); 
    root?.style.setProperty('--radial-gradient' , `radial-gradient(circle at 50% 50%, ${updated.palette.secondary.main} 0%, transparent 90% ), ${updated.palette.primary.main}` );
    root?.style.setProperty('--text-white', `${updated.palette.customColors.white}`);
    root?.style.setProperty('--preview-bg-color', `${updated.palette.background.default}`);
  },[partnerTheme]);
    return (
        <ThemeProvider theme={theme}>
          <div className="preview-theme">
            <Vtec isPreview={true} />
          </div>
        </ThemeProvider>
        
    );
}